
        // Get references to the video and image elements
        var videoElement = document.getElementById('video');
        var imgElement = document.getElementById('img');

        if (videoElement) {
            // Ensure controls are hidden immediately
            videoElement.controls = false;

            // Attempt to play the video
            var playPromise = videoElement.play();

            if (playPromise !== undefined) {
                playPromise.then(function() {
                    // Autoplay started successfully
                    if (imgElement) {
                        imgElement.style.display = "none";  // Hide the image
                    }
                    videoElement.style.display = "block";    // Show the video

                    // Keep the video non-interactive
                    videoElement.style.pointerEvents = "none";
                }).catch(function(error) {
                    // Autoplay was prevented
                    videoElement.style.display = "none";      // Hide the video
                    if (imgElement) {
                        imgElement.style.display = "block";   // Show the image
                    }
                });
            } else {
                // The play method is not supported
                videoElement.style.display = "none";          // Hide the video
                if (imgElement) {
                    imgElement.style.display = "block";       // Show the image
                }
            }
        }
  